import React, { useContext } from 'react';
import { useQuery } from 'react-query';
import { FormControl, TagPicker } from 'rsuite';
import { fetchTaxList } from '../api';
import { useLocation } from '../hooks/useLocation';
import { EquipmentContext } from '../utils/scope';

export const FilterComboMulti = ({ name, placeholder }) => {
  const { params, go } = useLocation();
  const scope = useContext(EquipmentContext);

  const { category, page, order, view, ...filters } = params;

  let filtersServer = { ...filters };
  delete filtersServer[name];

  const { status, data, error } = useQuery(
    [scope, 'tax', name, category, filtersServer],
    fetchTaxList,
  );

  if (status === 'loading') {
    return (
      <FormControl
        className="filter"
        placeholder={placeholder}
        disabled
        accepter={TagPicker}
        data={[]}
      />
    );
  }

  if (status === 'error') {
    return <span>Error: {error.message}</span>;
  }

  const v = params[name] || '';
  const value = v ? v.split(',') : [];

  return (
    <FormControl
      className="filter"
      placeholder={placeholder}
      accepter={TagPicker}
      data={data.items.map((item) => ({
        label: `${item.name} (${item.count})`,
        value: item.slug,
      }))}
      value={value}
      onChange={(v) => {
        const vals = { [name]: v && v.length ? v.join(',') : null };
        go({ ...params, ...vals });
      }}
    />
  );
};
